import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { AlarmLevelResolverPipe } from '../pages/notifications/pipes/alarm-level-resolver.pipe';
import { AlarmSelectionTypeResolverPipe } from '../pages/notifications/pipes/alarm-selection-type-resolver.pipe';
import { AlarmTypeIconPipe } from '../pages/notifications/pipes/alarm-type-icon.pipe';
import { AlarmTypeResolverPipe } from '../pages/notifications/pipes/alarm-type-resolver.pipe';
import { OrganisationTypeDisplayPipe } from '../pages/organisations/pipes/organisation-type-display.pipe';
import { GetReportIconPipe } from '../pages/reports/pipes/get-report-icon.pipe';
import { ReportJobIntervalPipe } from '../pages/reports/pipes/report-job-interval.pipe';
import { LocationToLatLngLiteralPipe } from './components/maps/pipes/location-to-lat-lng-literal.pipe';
import { AddressPipe } from './pipes/address.pipe';
import { ContactTypeResolverPipe } from './pipes/contact-type-resolver.pipe';
import { DimensionSystemUnitPipe } from './pipes/dimension-unit/dimension-system-unit.pipe';
import { DimensionUnitConverterPipe } from './pipes/dimension-unit/dimension-unit-converter.pipe';
import { DueDateRemainingValuePipe } from './pipes/due-date-remaining-value.pipe';
import { DueDatePipe } from './pipes/due-date.pipe';
import { EquipmentStatusCategoryPipe } from './pipes/equipment-status-category.pipe';
import { FileTypeIconPipe } from './pipes/file-type-icon.pipe';
import { FilterByValuePipe } from './pipes/filter-by-value.pipe';
import { FilterSingleOptionDisplayNamePipe } from './pipes/filter-single-option-display-name.pipe';
import { FormatDateTimePipe } from './pipes/format-date-time.pipe';
import { GroupByPipe } from './pipes/group-by.pipe';
import { IconPipe } from './pipes/icon.pipe';
import { IntervalDurationResolverPipe } from './pipes/interval-duration-resolver.pipe';
import { MaintenanceCategoryPipe } from './pipes/maintenance-category.pipe';
import { MaintenanceResultPipe } from './pipes/maintenance-result.pipe';
import { OperatingHoursPipe } from './pipes/operating-hours.pipe';
import { RemainingValueTypePipe } from './pipes/remaining-value-type.pipe';
import { SearchFilterTypePipe } from './pipes/search-filter-type.pipe';
import { SubmitterInfoPipe } from './pipes/submitter-info.pipe';
import { TranslateI18nObjectPipe } from './pipes/translate-i18n-object.pipe';
import { UserStatusPipe } from './pipes/user-status.pipe';
import { WarningLevelPipe } from './pipes/warning-level.pipe';

// Module includes pipes that are supposed to be injected into other injectable entities (services, pipes, directives)
// It is not obligatory to add all shared pipes to this module
@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    DecimalPipe,
    OperatingHoursPipe,
    TranslateI18nObjectPipe,
    ContactTypeResolverPipe,
    AddressPipe,
    FormatDateTimePipe,
    MaintenanceCategoryPipe,
    AlarmLevelResolverPipe,
    AlarmTypeResolverPipe,
    AlarmTypeIconPipe,
    AlarmSelectionTypeResolverPipe,
    TranslateI18nObjectPipe,
    SubmitterInfoPipe,
    UserStatusPipe,
    DimensionSystemUnitPipe,
    DimensionUnitConverterPipe,
    IntervalDurationResolverPipe,
    FilterSingleOptionDisplayNamePipe,
    EquipmentStatusCategoryPipe,
    SearchFilterTypePipe,
    LocationToLatLngLiteralPipe,
    OrganisationTypeDisplayPipe,
    DueDatePipe,
    RemainingValueTypePipe,
    DueDateRemainingValuePipe,
    WarningLevelPipe,
    MaintenanceResultPipe,
    DecimalPipe,
    IconPipe,
    GroupByPipe,
    ReportJobIntervalPipe,
    FilterByValuePipe,
    FileTypeIconPipe,
    GetReportIconPipe,
  ],
})
export class SharedPipesProvidersModule {}
